module.exports = __webpack_public_path__ + "img/f17.66997b49.jpg";